var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"background"},[(_vm.index != _vm.length+1)?_c('div',{staticClass:"bar",style:({
				width: (100.0 * _vm.index / _vm.length) + '%'
			})}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }